define('views/parts/form/multiple-selector',[
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/toastr-service',
    // views
    'views/parts/form/select',
    'views/parts/alert/alert-list',
    // templates
    'text!templates/parts/form/multiple-selector.html'

], function(
    _, Backbone, Mustache, U,
    // services
    ToastrService,
    // Views
    VSelect,
    VAlertList,
    // templates
    TMultipleSelector
) {

    var VMultipleSelector = Backbone.View.extend({
        template: TMultipleSelector,

        regions: {
            alert: '.alert-list',
            select: '.select'
        },

        events: {
            'click .delete-icon': 'onDeleteClick',
        },

        initialize: function(options) {
            this.options =_.extend(this, options);

            this.selectedItems = [];

            if (!this.selectOptions) this.selectOptions = { label: 'title', value: 'id' };

            this.view = {
                alert: new VAlertList({ collection: new Backbone.Collection() }),
                select: new VSelect({
                    option: this.selectOptions,
                    attribute: this.selectOptions.value,
                    model: new Backbone.Model().set(this.selectOptions.label, '').set(this.selectOptions.value, ''),
                    collection: this.collection,
                    noneSelectedText: this.noneSelectedText,
                    skipTranslation: true
                })
            };

            this.listenTo(this.collection, 'sync', this.render);
            this.listenTo(this.view.select, 'change', this.onSelectValueChange);
        },

        render: function() {
            this.selectedItems = [];
            this.renderContent();
            return this;
        },

        showErrorIfCollectionEmpty: function() {
            this.view.alert.reset();
            if (this.collection.models.length === 0) {
                this.view.alert.addError(this.emptyCollectionError);
                this.view.select.$el.hide();
            }
        },

        getSelectedItems: function() {
            return this.selectedItems.map(function(selectedItem) {
                return selectedItem.value;
            });
        },

        renderContent: function() {
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext({
                collection: this.collection,
                helpText: this.helpText,
                items: this.selectedItems
            })));

            this.generateZones();

            this.assign(this.view.alert, this.zone.$alert)
                .assign(this.view.select, this.zone.$select);

            this.showErrorIfCollectionEmpty();
        },

        renderWithEvent: function() {
            this.trigger('selectedItems:changed');
            this.renderContent();
        },

        addItem: function(item) {
            if (_.where(this.selectedItems, { 'label': item.label, 'value': item.value }).length > 0)
                return ToastrService.error('you-cannot-assign-the-same-item-more-than-once');
            this.selectedItems.push(item);
        },

        onSelectValueChange: function() {
            var item = { label: this.view.select.getModelLabel(), value: this.view.select.getValue() };
            this.addItem(item);
            this.view.select.setValue(null, { silent: true });
            this.renderWithEvent();
        },

        onDeleteClick: function(event) {
            event.preventDefault();
            var itemId = this.$el.find(event.target).parent().parent().attr('data-id');
            this.selectedItems = _.without(this.selectedItems, _.findWhere(this.selectedItems, { value: itemId }));
            this.renderWithEvent();
        }

    });

    return VMultipleSelector;
});

